<template>
  <div class="card--1PL">
    <v-row align="center" no-gutters>
      <v-col cols="3" class="pl-3 pr-3">
        <v-row no-gutters>
          <!-- <span class="text--normal">{{shipment.departure * 1000 | justTime($i18n.locale)}} - {{shipment.arrival * 1000 | justTime($i18n.locale)}}</span>
          <span class="text--small">{{shipment.departure * 1000 | dateToReadableFull($i18n.locale)}}</span> -->
          <span class="text--normal">{{shipment.departureUTC | timeToReadableSchedule($i18n.locale)}} - {{shipment.arrivalUTC | timeToReadableSchedule($i18n.locale)}}</span>
        </v-row>
        <v-row no-gutters>
          <span class="text--small">{{shipment.pickupLocal.from | dateToReadableFullMoment($i18n.locale)}}</span>
        </v-row>
      </v-col>

      <v-col cols="4">
        <v-row no-gutters>
          <span
          v-if="shipment.carrierAssigned"
          class="text--normal"
          >
            {{shipment.carrier.name}}
          </span>
          <span
          v-else
          class="text--normal"
          >
            {{ getSignedInOrganization.name }}
          </span>
          <!-- <span class="text--small">{{shipment.vehicle.name}} <span class="card--dot">&#9679;</span> {{shipment.vehicle.plate_number}}</span> -->
          <div
          v-if="shipment.vehicleAssigned"
          class="card__vehicle"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="text--small vehicle-name">{{shipment.vehicle.name}}</span>
              </template>
              <span>{{shipment.vehicle.name}}</span>
            </v-tooltip>
            <span class="card--dot">&#9679;</span>
            <span class="text--small">{{shipment.vehicle.plate_number}}</span>
          </div>
        </v-row>
      </v-col>

      <v-col cols="2">
        <v-row class="pl-2">
          <span class="text--slim"><v-icon class="card--icon">fas fa-box</v-icon>
          {{shipment.weight | roundValueWeight(0)}} kg
          </span>
        </v-row>
        <v-row class="pl-2">
          <span class="text--slim"><v-icon class="card--icon">fa fa-arrows-alt</v-icon>
            {{shipment.volume| roundValue(1)}} m&sup3;
          </span>
        </v-row>
      </v-col>

      <v-col cols="3" class="pl-4">
        <v-row justify="end" >
          <span
            v-for="(label, index) in shipment.labels"
            :key="index"
            v-show="index === 0 && label !== ''"
            class="card--label label-green">{{label}}</span>
          <span v-show="shipment.status" class="card--label label-purple">{{$t('shipments.'+shipment.status)}}</span>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Card1PL',
  props: {
    shipment: Object
  },
  computed: {
    ...mapGetters([
      'getSignedInOrganization'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .card--1PL {
    .text--normal {
      font-size: 14px;
      color: #484848;
      font-weight: 500;
    }
    .text--small {
      font-size: 13px;
      color: #767676;
      text-align: left;
    }
    .text--slim {
      font-size: 13px;
      color: #767676;
      text-align: left;
    }
    .card--dot {
      color: #767676;
      font-size: 11px;
      margin-left: 2px;
      margin-right: 2px;
    }
    .card--icon {
      font-size: 13px;
      font-weight: bold;
      color: #767676;
    }
    .card__vehicle {
      display: flex;
      min-width: 0;
      .vehicle-name {
        display: inline-block;
        width: 138px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .card--label {
      font-size: 11px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      padding: 2px 8px;
      border-radius: 20px;
      margin-right: 5px;
      margin-bottom: 1px;
      &.label-green {
        background-color: #50E898;
      }
      &.label-pink {
        background-color: #ef476f;
      }
      &.label-purple {
        background-color: #6A68CD;
      }
    }
  }
</style>
